import { withStyles } from "@material-ui/core/styles";
import ItemCustom from "./ItemCustom";
import styles from "./styles";

export default withStyles(styles)(ItemCustom);
